<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.15713 11.4562L11.4698 4.14479C11.5764 4.03738 11.7504 4.03738 11.8579 4.14479C11.9652 4.25219 11.9652 4.42546 11.8579 4.53286L4.54594 11.8435C4.49187 11.8976 4.42201 11.9242 4.35149 11.9242C4.28096 11.9242 4.21043 11.8968 4.15713 11.8435C4.05042 11.7361 4.05042 11.5636 4.15713 11.4562Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2248 1.60784L14.3915 3.77398C14.7584 4.14088 14.7584 4.73749 14.3915 5.1044L5.76971 13.7274C5.5698 13.9273 4.18449 14.2425 1.65398 14.6627C1.64451 14.6646 1.63532 14.6656 1.62632 14.6661C1.62039 14.6665 1.61446 14.6666 1.60852 14.6666C1.53637 14.6666 1.46584 14.6376 1.41407 14.5858C1.35139 14.5239 1.32229 14.4337 1.33722 14.3467C1.75896 11.816 2.07332 10.4307 2.27247 10.2316L10.8951 1.60784C11.2613 1.24251 11.8586 1.24094 12.2248 1.60784ZM5.3965 13.3244L14.0042 4.71632C14.1564 4.56345 14.1564 4.31493 14.0042 4.16127L11.8375 1.99513C11.7614 1.91909 11.6611 1.88067 11.56 1.88067C11.4596 1.88067 11.3593 1.91909 11.2824 1.99591L2.66129 10.6189C2.54923 10.8141 2.21764 12.4612 1.94327 14.0574C3.51892 13.787 5.14491 13.4585 5.3965 13.3244Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconPencil",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
